module.exports = __webpack_public_path__ + "static/media/S2N1-3.15ead884.svg";